import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import * as Utils from './lib/utils';
import { tap, catchError } from 'rxjs/operators';
import { HelpersService } from './services/helpers.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private helpersService: HelpersService) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const loading = request.url.includes('p2p') ? true : false;

    const headers = { Authorization: `Bearer ${this.helpersService.accessToken}` };

    if (loading) {
      this.helpersService.showLoader();
    }

    request = request.clone({
      setHeaders: headers,
    });

    return next.handle(request).pipe(
      tap((evt) => {
        if (evt instanceof HttpResponse) {
          if (loading) {
            this.helpersService.hideLoader();
          }
        }
      }),
      catchError((err) => {
        if (err instanceof HttpErrorResponse) {
          if (loading) {
            this.helpersService.hideLoader();
          }
        }
        if (err.error.code >= 400 && request.url.includes('p2p')) {
          this.helpersService.handleError(null, err.message);
        }
        return throwError(err);
      }),
    );
  }
}
